<app-dialog headerGlyph="trash" [headerText]="title" saveText="Close" [showTopCancelButton]="false" [showSaveButton]="false" cancelText="Close"
            [body]="body" [validationFn]="validate.bind(this)">
    <ng-template #body>
        @if (!loading) {
            <div class="container">
                <div [innerHTML]="msg"></div>
            </div>
        }
    </ng-template>
</app-dialog>
